module.exports = "/_next/static/images/profile-ghi-cedde7cd8b7fb137b82308d3f2e438a8.png";